import { render, staticRenderFns } from "./Image&Text.vue?vue&type=template&id=6d50feea&scoped=true&lang=pug"
import script from "./Image&Text.vue?vue&type=script&lang=js"
export * from "./Image&Text.vue?vue&type=script&lang=js"
import style0 from "./Image&Text.vue?vue&type=style&index=0&id=6d50feea&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d50feea",
  null
  
)

export default component.exports